import { mapGetters } from "vuex";
import pageheader from "../../pageheader";
import CustomerScopeNotice from "@/components/Common/CustomerScopeNotice";
import utils from "../../../utils/util";
import rules from "../../../utils/rules";
import telematicsService from "../../../api/telematics.service";
import moment from "moment";

export default {
  name: "jobsite-access-codes",
  components: { pageheader, CustomerScopeNotice },

  data() {
    return {
      input: {},
      rules: rules,
      formValid: false,
      search: "",
      isJobistesAccessCodesLoading: false,
      jobsiteAccessCodesList: [],
      delDialog: false,
      isdeleting: false,
      selectedRecord: {},
      enableTable: false,
      accessCode: "",
      description: "",
      updateDialog: false,
      isUpdating: false,
      headers: [
        { text: "Actions", value: "action" },
        { text: "Jobsite Code", value: "id" },
        { text: "Jobsite Name", value: "locationName" },
        { text: "Access Code", value: "accessCode" },
        { text: "Description", value: "description" },
        { text: "Created", value: "createdBy" },
        { text: "Last Modified", value: "modifiedBy" },
      ],
    };
  },

  computed: {
    ...mapGetters(["roles", "companyIdDropdown"]),
  },

  watch: {
    // BE-1121: the list is scoped to the toolbar customer and used to be fetched
    // once on mount, so switching customers showed the previous one's codes.
    companyIdDropdown() {
      this.jobsiteAccessCodesList = [];
      this.enableTable = Boolean(this.companyIdDropdown);
      if (this.enableTable) {
        this.getJobsitesAccessCodes();
      }
    },
  },

  mounted() {
    this.input = utils.getInputContent("jobsitesaccesscodes", this.roles);
    this.enableTable = Boolean(this.$store.getters.companyIdDropdown);
    if (this.enableTable) {
      this.getJobsitesAccessCodes();
    }
  },

  filters: {
    formatDates: function (value) {
      if (value) {
        const format = "MM/DD/YYYY";
        return moment(value).format(format);
      } else {
        let emptydata = "";
        return emptydata;
      }
    },
  },

  methods: {
    async getJobsitesAccessCodes() {
      try {
        this.isJobistesAccessCodesLoading = true;
        this.jobsiteAccessCodesList = [];
        let response = await telematicsService.getJobsitesAccessCodes();
        this.jobsiteAccessCodesList = response.data ? response.data : [];
        this.isJobistesAccessCodesLoading = false;
      } catch (error) {
        console.log(error);
        this.isJobistesAccessCodesLoading = false;
      }
    },

    openEditPopup(item) {
      this.updateDialog = true;
      this.selectedRecord = item;
      this.accessCode = this.selectedRecord.accessCode;
      this.description = this.selectedRecord.description;
    },

    async updateJobsiteAccessCode() {
      this.isUpdating = true;
      let payload = {
        id: this.selectedRecord.id,
        customerId: this.selectedRecord.customerId,
        accessCode: this.accessCode,
        description: this.description,
      };
      let response = await telematicsService.updateJobsiteAccessCode(payload);
      if (response.isSuccess) {
        this.$toast.success("Jobsite Access Code updated successfully.");
        this.updateDialog = false;
        this.isUpdating = false;
        this.getJobsitesAccessCodes();
      }
    },

    confirmDelete(item) {
      this.delDialog = true;
      this.selectedRecord = item;
    },

    async deletejobsiteAccessCode(id) {
      try {
        this.isdeleting = true;
        let response = await telematicsService.deletejobsiteAccessCode(id);
        if (response) {
          this.$toast.success("Jobsite Access Code deleted successfully.");
          this.delDialog = false;
          this.getJobsitesAccessCodes();
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
